import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GamificationRoutingModule } from './gamification-routing.module';
import { SharedModule } from '../_shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../_material/material.module';
import { GamificationPage } from './page/gamification.page';
import { GamificationSkeletonComponent } from './components/gamification-skeleton/gamification-skeleton.component';
import { GamificationRankingCardComponent } from './components/gamification-ranking/components/gamification-ranking-card/gamification-ranking-card.component';
import { GamificationMonthlyRankingComponent } from './components/gamification-ranking/gamification-ranking.component';
import { MonthlyRankingImageComponent } from './components/gamification-ranking/components/monthly-ranking-image/monthly-ranking-image.component';
import { GeneralRankingImageComponent } from './components/gamification-ranking/components/general-ranking-image/general-ranking-image.component';
import { GamificationBadgesComponent } from './components/gamification-badges/gamification-badges.component';
import { GamificationBadgeComponent } from './components/gamification-badges/components/badge/gamification-badge.component';
import { BadgeSvgComponent } from './components/gamification-badges/components/badge-svg/badge-svg.component';
import { RankingComponent } from './components/gamification-ranking/components/ranking/ranking.component';
import { ScoreComponent } from './components/gamification-ranking/components/score/score.component';
import { SlotComponent } from './components/gamification-ranking/components/ranking/components/slot.component';
import { ScoreSkeletonComponent } from './components/gamification-ranking/components/score/components/score-skeleton.component';

@NgModule({
  declarations: [
    GamificationPage,
    GamificationSkeletonComponent,
    GamificationRankingCardComponent,
    GamificationMonthlyRankingComponent,
    MonthlyRankingImageComponent,
    GeneralRankingImageComponent,
    GamificationBadgesComponent,
    GamificationBadgeComponent,
    BadgeSvgComponent,
    RankingComponent,
    ScoreComponent,
    ScoreSkeletonComponent,
    SlotComponent,
  ],
  imports: [
    CommonModule,
    GamificationRoutingModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GamificationModule {}
